import React from 'react'

import { AdoptionComponent } from '../../constants/AdoptionComponent'
import { useDsAdoptionAttribute } from '../../utils/dsAdoption'

import cm from './Skeleton.module.css'

interface SkeletonImageProps {
  /** The width of the image skeleton */
  width?: number
  /** The height of the image skeleton */
  height?: number
  /** The className to apply to the image skeleton */
  className?: string
  'data-test-id'?: string
}

const SkeletonImage = ({
  width,
  height,
  className = '',
  'data-test-id': dataTestId,
}: SkeletonImageProps) => {
  const adoptionAttribute = useDsAdoptionAttribute(AdoptionComponent.SKELETON_IMAGE)

  return (
    <div
      className={`${cm.skeleton} ${className}`}
      style={{ width, height }}
      data-test-id={dataTestId}
      {...adoptionAttribute}
    />
  )
}

export default SkeletonImage
